"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = void 0;
var axios_1 = __importDefault(require("axios"));
var axios_2 = __importDefault(require("axios"));
var tools_1 = require("./tools");
var Config = {
    BASE_URL: 'https://m.lizhiweike.com' // 正式接口
};
axios_1.default.interceptors.request.use(function (config) {
    return new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
        var token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = '';
                    if (!((tools_1.isLZWKAPP()) && window.localStorage.getItem('_token') && window.localStorage.getItem('_token') !== '')) return [3 /*break*/, 1];
                    config.headers.common.Authorization = window.localStorage.getItem('_token');
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, new Promise(function (resolve) {
                        return window.Session.getToken(function (_a) {
                            var token = _a.token;
                            return resolve(token);
                        });
                    })];
                case 2:
                    token = _a.sent();
                    _a.label = 3;
                case 3:
                    if (!config.params) {
                        config.params = {};
                    }
                    if (!tools_1.isLZWKAPP()) {
                        config.params.token = token;
                    }
                    resolve(config);
                    return [2 /*return*/];
            }
        });
    }); });
});
var Request = /** @class */ (function () {
    function Request(requestUrl) {
        if (requestUrl) {
            Config.BASE_URL = requestUrl;
        }
    }
    Request.getData = function (response) {
        var data = response.data;
        if (data.code === 0) {
            return data;
        }
        else {
            throw data;
        }
    };
    Request.prototype.$get = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var token, _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!(tools_1.isLZWKAPP() && window.localStorage.getItem('_token') && window.localStorage.getItem('_token') !== '')) return [3 /*break*/, 2];
                        token = window.localStorage.getItem('_token');
                        axios_1.default.defaults.headers.common['Authorization'] = token;
                        _b = (_a = Request).getData;
                        return [4 /*yield*/, axios_1.default.get(Config.BASE_URL + url, options)];
                    case 1: return [2 /*return*/, _b.apply(_a, [_e.sent()])];
                    case 2:
                        _d = (_c = Request).getData;
                        return [4 /*yield*/, axios_1.default.get(Config.BASE_URL + url, options)];
                    case 3: 
                    // const axios = await this.getAxios();
                    return [2 /*return*/, _d.apply(_c, [_e.sent()])];
                }
            });
        });
    };
    Request.prototype.$post = function (url, data, options) {
        return __awaiter(this, void 0, void 0, function () {
            var token, _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!(tools_1.isLZWKAPP() && window.localStorage.getItem('_token') && window.localStorage.getItem('_token') !== '')) return [3 /*break*/, 2];
                        token = window.localStorage.getItem('_token');
                        axios_1.default.defaults.headers.common['Authorization'] = token;
                        _b = (_a = Request).getData;
                        return [4 /*yield*/, axios_1.default.post(Config.BASE_URL + url, data, options)];
                    case 1: return [2 /*return*/, _b.apply(_a, [_e.sent()])];
                    case 2:
                        axios_2.default.create({
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                        });
                        _d = (_c = Request).getData;
                        return [4 /*yield*/, axios_1.default.post(Config.BASE_URL + url, data, options)];
                    case 3: return [2 /*return*/, _d.apply(_c, [_e.sent()])];
                }
            });
        });
    };
    return Request;
}());
exports.Request = Request;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@weike/operation-report/dist/utils/request.js
// module id = 387
// module chunks = 0